import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import CourseCard from '../components/CourseCard';
import { getCourses } from '../utils/api';

export default function CoursesPage() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCourses().then(r => setCourses(r.data.courses || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ paddingTop: 70 }}>
      <style>{`
        .courses-hero { background: linear-gradient(135deg, #0f172a, #1e3a5f); padding: 64px 0; text-align: center; }
        .courses-hero h1 { color: white; font-size: clamp(28px, 4vw, 44px); margin-bottom: 14px; }
        .courses-hero p { color: #94a3b8; font-size: 17px; max-width: 560px; margin: 0 auto 32px; }
        .courses-features { display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; margin-top: 8px; }
        .courses-feature { display: flex; align-items: center; gap: 8px; color: #93c5fd; font-size: 14px; font-weight: 500; }
      `}</style>
      <div className="courses-hero">
        <div className="container">
          <div className="section-label" style={{ background: 'rgba(26,86,219,0.2)', color: '#93c5fd', margin: '0 auto 16px' }}>Industry-Ready Programs</div>
          <h1>Choose Your Path to a <span style={{ color: 'var(--accent)' }}>Tech Career</span></h1>
          <p>3 focused programs designed to make you job-ready in 2–3 months with real projects, paid internship, and placement support.</p>
          <div className="courses-features">
            {['✓ 2–3 Month Programs', '✓ Paid Internship Included', '✓ Placement Assistance', '✓ Certificate of Completion'].map((f, i) => (
              <div key={i} className="courses-feature">{f}</div>
            ))}
          </div>
        </div>
      </div>

      <section className="section">
        <div className="container">
          {loading ? (
            <div className="spinner-wrap"><div className="spinner" /></div>
          ) : (
            <div className="grid-3">
              {courses.map(c => <CourseCard key={c._id} course={c} />)}
            </div>
          )}

          <div style={{ textAlign: 'center', marginTop: 56, padding: '40px', background: 'var(--bg)', borderRadius: 'var(--radius-xl)', border: '1px solid var(--border)' }}>
            <h3 style={{ fontSize: 22, marginBottom: 10 }}>Not sure which program is right for you?</h3>
            <p style={{ color: 'var(--mid)', marginBottom: 24 }}>Talk to our advisors — we'll help you pick the perfect program based on your background and goals.</p>
            <Link to="/contact" className="btn btn-primary">Talk to an Advisor <FiArrowRight /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
